// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1Sb9d","colMin":"styles_colMin__1Pp-x","colCheckbox":"styles_colCheckbox__a-ABR"};